export default "/images/19ec9a69c7d3a35ff5afaeadee3cb0d8.avif";